export default __webpack_public_path__ + "static/media/promo_00.b20d076a.jpg";